/*
|--------------------------------------------------------------------------
| GH Web App
|--------------------------------------------------------------------------
*/
/**
 * @namespace
 */
var __gh__webApp 					= __gh__webApp || {};
	__gh__webApp.analytics 			= __gh__webApp.analytics || {},
	__gh__webApp.analytics.google 	= __gh__webApp.analytics.google || {},
	__gh__webApp.comments 			= __gh__webApp.comments || {},
	__gh__webApp.consumerMarketing 	= __gh__webApp.consumerMarketing || {},
	__gh__webApp.data 				= __gh__webApp.data || {},
	__gh__webApp.data.validate 		= __gh__webApp.data.validate || {},
	__gh__webApp.feedPreparsers 	= __gh__webApp.feedPreparsers || {},
	__gh__webApp.siteForms 			= __gh__webApp.siteForms || {},
	__gh__webApp.social 			= __gh__webApp.social || {},
	__gh__webApp.pages				= __gh__webApp.pages || {},
	__gh__webApp.pages.external		= __gh__webApp.pages.external || {},
	__gh__webApp.paywall 			= __gh__webApp.paywall || {},
	__gh__webApp.utilities 			= __gh__webApp.utilities || {},
	__gh__webApp.video 				= __gh__webApp.video || {},
	__gh__webApp.video.main 		= __gh__webApp.video.main || {},
	__gh__webApp.views 				= __gh__webApp.views || {};
	__gh__webApp.views.takeover 	= __gh__webApp.views.takeover || {};
	__gh__webApp.weather 			= __gh__webApp.weather || {};